import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const SECTION_SELECTOR = '[data-component="product-acf-slider"]';

const initSingleProductAcfSlider = (section) => {
    const sliderElement = section.querySelector('.js-product-acf-slider');
    if (!(sliderElement instanceof Element) || sliderElement.dataset.swiperReady === '1') {
        return;
    }

    const slidesCount = sliderElement.querySelectorAll('.swiper-slide').length;
    if (!slidesCount) {
        return;
    }

    const paginationElement = section.querySelector('.swiper-pagination');
    const prevElement = section.querySelector('.swiper-button-prev');
    const nextElement = section.querySelector('.swiper-button-next');

    const sliderOptions = {
        modules: [Pagination, Navigation],
        slidesPerView: 1,
        spaceBetween: 12,
        speed: 550,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
        },
    };

    if (slidesCount > 1 && paginationElement) {
        sliderOptions.pagination = {
            el: paginationElement,
            clickable: true,
        };
    }

    if (slidesCount > 1 && prevElement && nextElement) {
        sliderOptions.navigation = {
            prevEl: prevElement,
            nextEl: nextElement,
        };
    }

    new Swiper(sliderElement, sliderOptions);
    sliderElement.dataset.swiperReady = '1';

    const controlsElement = section.querySelector('.ProductAcfSlider__controls');
    if (controlsElement && slidesCount <= 1) {
        controlsElement.hidden = true;
    }
};

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSingleProductAcfSlider);
});
